import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './style.css'

class NRTSelectInput extends Component {

    state = { value: null }


    componentWillMount() {
        this.setState({ value : this.props.value })
    }


    handleChange = (selectedOption) => {
        this.setState(
            {value: selectedOption.value},
            () => this.props.onChange(selectedOption.value)
        )
    }

    focus() { this.input.focus(); }


    render() {

        const { value } = this.state

        const {
            options,
            clearable

        } = this.props


        return (
            <Select
                ref={i=>this.input = i}
                value={value}
                onChange={this.handleChange}
                options={options}
                className={'nrt-select-input'}
                optionClassName={'nrt-select-option'}
                clearable={clearable}
            />
        )
    }
}


NRTSelectInput.propTypes = {
    value: PropTypes.any,
    options: PropTypes.array.isRequired,
    clearable: PropTypes.bool,
}

NRTSelectInput.defaultProps = { clearable : false }


export default NRTSelectInput



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/SelectInput/index.js